import React, { useCallback, useEffect, useState } from 'react';

import Upload from '../Elements/Uploading';
import { Panel, PanelFooter, PanelHeader, PanelLabel, PanelStatistic, PanelStatistics, PanelStatisticsFooter, PanelValue } from '../Panel/Panel';
import { useDispatch } from 'react-redux';
import { get_statistics } from '@/redux/new_services/elements';

export const ElementsUsage = ({small = false}) => {
  const dispatch = useDispatch();

  const [count, setCount] = useState(null);
  const [usage, setUsage] = useState('');
  const [loaded, setLoaded] = useState(false);

  const loadStatistics = useCallback(() => {
    get_statistics().then((data) => {
      console.info(data);
      if (data.data) {
        if (data.data.count) {
          setCount(data.data.count);
        }
        if (data.data.total) {
          setUsage(data.data.total);
        }
        setLoaded(true);
      }
    });
  },[setLoaded, setUsage, setCount]);

  useEffect(() => {
    loadStatistics();
  }, [loadStatistics]);

  return (
    <Panel halfSize={small}>
      <PanelHeader
        header
        helpText="Zeigt die Anzahl der eigenen Medien und den Speicherverbrauch an.">
        Elemente
      </PanelHeader>
      <PanelStatistics>
        <PanelStatistic>
          <PanelValue isLoading={!loaded}>{count}</PanelValue>
          <PanelStatisticsFooter>Elemente</PanelStatisticsFooter>
        </PanelStatistic>
        <PanelStatistic>
          <PanelValue isLoading={!loaded}>{usage}</PanelValue>
          <PanelStatisticsFooter>Größe</PanelStatisticsFooter>
        </PanelStatistic>
      </PanelStatistics>
      <Upload />
      <PanelFooter></PanelFooter>
    </Panel>
  );
};

export const ElementsUpload = () => {
  return (
    <Panel halfSize>
      <PanelHeader header>
        Medien hochladen
      </PanelHeader>
      <PanelLabel>
        Lade neue Elemente, wie Videos oder Bilder hoch.
      </PanelLabel>
      <Upload />
      <PanelFooter></PanelFooter>
    </Panel>
  );
};
